// define a mixin object

export const labMixin = {
    props: {value: Number, width: String, height: String, unselectable: Boolean},
    data() {
        return {
            selected: null,
            numImages: null
        }
    },
    created() {
        this.selected = this.value;
    },
    watch: {
        value(newValue) {
            this.selected = newValue
        }
    },
    computed: {
        images() {
            let res = [];
            for (let i = 1; i <= this.numImages; i++) {
                res.push(this.$options.components['Image' + i])
            }
            return res
        }
    },
    methods: {
        adjustSize(value, index) {
            if (!this.selected) return value;
            /*if (index === this.selected) {
                return Number(value.slice(0, -2))*1.2 + 'px'
            }
            return Number(value.slice(0, -2))*0.8 + 'px'*/
            return value;
        },

        clicked(value) {
            if (this.unselectable) return;
            if (this.selected === value) this.selected = null;
            else this.selected = value;
            this.$emit('input', this.selected);
            this.$emit('change', this.selected);
        }
    }
};
